import createCrudVuexModule from "@/store/crud";

export const directCollectMethod = createCrudVuexModule({
  namespaced: true,
  path: "/library/direct-collect-method",
});

export const workspaceDirectCollectMethod = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/direct-collect-method",
});

export const managementDirectCollectMethod = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/direct-collect-method",
});

export const otherCollectMethod = createCrudVuexModule({
  namespaced: true,
  path: "/library/other-collect-method",
});

export const workspaceOtherCollectMethod = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/other-collect-method",
});

export const managementOtherCollectMethod = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/other-collect-method",
});
